import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Tooltip } from '@mui/material';
import { MessageDescriptor, useIntl } from 'react-intl';
import { scheduleStatusHelpMessage } from './schedule-status-spot-messages';

interface ScheduleStatusHelpTooltipProps {
  message?: MessageDescriptor;
}

/**
 * Help icon explaining coverage labels, numbers, and the off-tolerance warning.
 */
export function ScheduleStatusHelpTooltip({
  message = scheduleStatusHelpMessage,
}: ScheduleStatusHelpTooltipProps) {
  const { $t } = useIntl();

  return (
    <Tooltip
      title={$t(message)}
      slotProps={{
        tooltip: {
          sx: { whiteSpace: 'pre-line', maxWidth: 360 },
        },
      }}
    >
      <Box
        component="span"
        sx={{ display: 'inline-flex', color: 'text.secondary', cursor: 'help' }}
      >
        <HelpOutlineIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
}
